import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../../api";
import { NotebookPage } from "../../types/note";

export interface QueryViewPagesResult {
  pages: NotebookPage[];
  count: number;
}

export const queryViewPages: (config: {
  "view-id": string;
  skip: number;
  limit: number;
}) => Promise<QueryViewPagesResult> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config as any, { keysAs: "string" });
  const query = `
    (datastore Qo.Public.Api.Page.View.Query "omega/query-omega/public/api/page/view/query")
    (Qo.Public.Api.Page.View.Query/query-view-pages ${ednString} Response)
    (return [Response])
  `;
  return queryOmegaSingleResult(query);
};
